import { render, staticRenderFns } from "./MovementHistoryList.vue?vue&type=template&id=87b82624"
import script from "./MovementHistoryList.vue?vue&type=script&lang=js"
export * from "./MovementHistoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports